import React from 'react'
import PageHeader from '../shared/pageHeader/PageHeader'
import Footer from '../shared/Footer'
import Header from '../shared/header/Header'
import NavigationMenu from '../shared/navigationMenu/NavigationMenu'
import CityHeader from './CityHeader'
import CityTable from './CityTable'

const CityList = () => {
    return (
        <>

            <Header />
            <NavigationMenu />
            <main className="nxl-container">
                <div className="nxl-content">
                    <PageHeader >
                        <CityHeader />
                    </PageHeader>
                    <div className='main-content'>
                        <div className='row'>
                            <CityTable />
                        </div>
                    </div>
                    <Footer />
                </div>
            </main>
        </>
    )
}

export default CityList